import { defineSourceAdapter, SOURCE_ADAPTER_TYPES } from '@ingestion-core';

export function createJiraRestSourceAdapter(repository,connectionId){
  if(!repository)throw new Error('Jira REST adaptor requires the model repository');
  if(!connectionId)throw new Error('Jira REST adaptor requires a connection ID');

  let metadataCache=null;
  const metadata=async(force=false)=>{
    if(!metadataCache||force)metadataCache=await repository.getJiraMetadata(connectionId);
    return metadataCache;
  };

  const adapter=defineSourceAdapter({
    type:SOURCE_ADAPTER_TYPES.JIRA_REST,
    async testConnection(){
      return repository.testSourceConnection(connectionId);
    },
    async getSourceMetadata(){
      return metadata();
    },
    async getAvailableProcesses(){
      const m=await metadata();
      return {projects:m.projects||[],issueTypes:m.issueTypes||[],favouriteFilters:m.favouriteFilters||[]};
    },
    async getAvailableFields(){
      const m=await metadata();
      return m.fields||[];
    },
    async preview(input={}){
      return repository.previewJiraScope(connectionId,input);
    },
    async extract(input={}){
      return repository.extractJiraModel(connectionId,input);
    },
    async refresh(input={}){
      return repository.extractJiraModel(connectionId,input);
    },
  });

  return Object.freeze({
    ...adapter,
    countScope:input=>repository.countJiraScope(connectionId,input),
    refreshMetadata:()=>metadata(true),
    connectionId,
  });
}
